import { Fragment, useRef, useState } from "react";
import { Dialog } from "@headlessui/react";

import { Button } from "src/components/shared/button/Button";
import styles from "./PortalTransitionModal.module.scss";

const COOKIE_NAME = "cc_portal_transition_modal_2026_09_28";
const COOKIE_MAX_AGE = 90 * 24 * 60 * 60;

function hasDismissed(): boolean {
  try {
    return document.cookie.split(";").some(
      (cookie) => cookie.trim() === `${COOKIE_NAME}=dismissed`
    );
  } catch {
    return false;
  }
}

export function PortalTransitionModal() {
  const [dismissed, setDismissed] = useState(hasDismissed);
  const headingRef = useRef<HTMLHeadingElement>(null);

  function dismiss() {
    setDismissed(true);
    try {
      const secure = window.location.protocol === "https:" ? "; Secure" : "";
      document.cookie = `${COOKIE_NAME}=dismissed; Max-Age=${COOKIE_MAX_AGE}; Path=/; SameSite=Lax${secure}`;
    } catch {
      // Allow dismissal for this visit even when cookies are unavailable.
    }
  }

  return (
    <Dialog
      open={!dismissed}
      onClose={() => { /* Only the Dismiss button closes this notice. */ }}
      initialFocus={headingRef}
      className={styles.root}
    >
      <Dialog.Overlay className={styles.overlay} />
      <div className={styles.panel}>
        <div className={styles.message}>
          <Dialog.Title as={Fragment}>
            <h2 ref={headingRef} tabIndex={-1} className={styles.title}>
              ACTION REQUIRED: Maintain Portal Access
            </h2>
          </Dialog.Title>
          <p>
            AdventHealth Centra Care is launching the new <strong>Employer Portal</strong> on <strong>September 28, 2026</strong>.
          </p>
          <p>
            To gain access, your Portal Administrator must contact your <strong>Corporate Sales Representative</strong> and submit the required access agreements <strong>as soon as possible</strong>.
          </p>
          <p>
            <strong>IMPORTANT:</strong><br />
            <strong>Organizations that do not complete the required agreements prior to 9/28/26 will lose portal access beginning 9/28/26.</strong>{" "}
            We are committed to making this transition as smooth as possible and will work closely with you throughout the process.
          </p>
          <p>
            Please note that <strong>access restoration may take up to 10 days after completed agreements are received and processed</strong>.
          </p>
        </div>
        <div className={styles.footer}>
          <Button primary type="button" className={styles.dismiss} onClick={dismiss}>
            Dismiss
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
